module.exports = __webpack_public_path__ + "static/media/hospital.24087e15.svg";